//requirePureCounterfrom'./js/purecounter.js';
//Storeitasconsant
constPureCounter=require('./js/purecounter').default;

//SetmoduleExporttoPureCounterclass,soitcanbeinitializeasclass
module.exports=PureCounter;